import { useAtom, useSetAtom } from "jotai";
import { type FC } from "react";
import {
    selectedSubthemesAtomFamily,
    selectedThemesAtomFamily,
} from "../../ctx";
import { DittoGuidanceActive } from "../DittoGuidanceActive";
import { DittoGuidanceSelector } from "../DittoGuidanceSelector";
import { selectedGroupingTypeAtomFamily } from "../ObjectiveTable/ctx";
import { isGuidanceActiveAtom, selectedFrameworkAtom } from "./ctx";
import { useFrameworkSpecificThemesAndSubthemes } from "./data";

import { useParams } from "react-router-dom";

export const DittoGuidance: FC = () => {
    const { org_uname } = useParams();

    const [selectedFramework, setSelectedFramework] = useAtom(
        selectedFrameworkAtom,
    );
    const [isGuidanceActive, setIsGuidanceActive] =
        useAtom(isGuidanceActiveAtom);
    const { themeIds, subthemeIds } =
        useFrameworkSpecificThemesAndSubthemes(selectedFramework);

    const setSelectedThemes = useSetAtom(selectedThemesAtomFamily(org_uname));
    const setSelectedGroupingType = useSetAtom(
        selectedGroupingTypeAtomFamily(org_uname),
    );
    const setSelectedSubthemes = useSetAtom(
        selectedSubthemesAtomFamily(org_uname),
    );

    const handleEnterGuidance = () => {
        // Since we only have one framework (EcoVadis), automatically select it
        setSelectedFramework("ecovadis");
        setSelectedThemes(themeIds);
        setSelectedSubthemes(subthemeIds);
        setSelectedGroupingType("subtheme");
        setIsGuidanceActive(true);
    };

    const handleExitGuidance = () => {
        // Clear the selection, the filters, and deactivate guidance
        setIsGuidanceActive(false);
        setSelectedFramework("");

        setSelectedThemes([]);
        setSelectedSubthemes([]);
    };

    // Show active guidance view when guidance is active
    if (isGuidanceActive && selectedFramework) {
        return <DittoGuidanceActive onExitGuidance={handleExitGuidance} />;
    }

    // Show selector when no guidance is active
    return <DittoGuidanceSelector onEnterGuidance={handleEnterGuidance} />;
};
